import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { Node, NodeSpec } from 'prosemirror-model';

/**
 * Defines block nodes that have block content.
 */
export class BlockContainerSchemaPlugin extends SchemaPlugin {
  nodes = {
    article: this.makeBlockContainer('article'),
    aside: this.makeBlockContainer('aside'),
    blockquote: this.makeBlockContainer('blockquote'),
    details: this.makeBlockContainer('details', node => {
      const outputSpec = nodeToDOM(node);
      // Set the open attribute to true so that the summary is always visible in the editor
      (outputSpec.dom as HTMLDetailsElement).open = true;
      return outputSpec;
    }),
    div: this.makeBlockContainer('div'),
    fieldset: this.makeBlockContainer('fieldset'),
    figcaption: this.makeBlockContainer('figcaption'),
    figure: this.makeBlockContainer('figure'),
    footer: this.makeBlockContainer('footer'),
    header: this.makeBlockContainer('header'),
    main: this.makeBlockContainer('main'),
    nav: this.makeBlockContainer('nav'),
    section: this.makeBlockContainer('section'),
    summary: this.makeBlockContainer('summary'),
  } satisfies Record<string, NodeSpec>;

  makeBlockContainer(tagName: string, toDOM?: (node: Node) => ReturnType<typeof nodeToDOM>): NodeSpec {
    return {
      group: 'block',
      content: 'block+',
      defining: true, // Persist and wrap the inserted content during replace operations
      fillIfContentDeleted: 'mcCentralContainer',
      parseDOM: [{ tag: tagName }],
      toDOM(node) {
        return toDOM?.(node) ?? nodeToDOM(node, { tagName });
      }
    };
  }
}
